import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ProcFeeAssignmentFeResponse } from '@pmp/api';

export const procurationFeeAssignmentsColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      sorter: true,
    },
    width: 80,
  },
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRuleId',
    dataIndex: 'procurationFeeRule',
    key: 'procurationFeeRuleId',
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRule',
    key: 'procurationFeeRule',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeId',
    dataIndex: 'procurationFee',
    key: 'procurationFeeId',
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
      hide: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFee',
    key: 'procurationFee',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const procurationFeeAssignmentsCRColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRuleId',
    key: 'procurationFeeRule',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFeeId',
    key: 'procurationFeeId',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
];

export const firmProcurationFeeCRColumns: TableColumns<ProcFeeAssignmentFeResponse> = [
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.firmId',
    dataIndex: 'firmId',
    key: 'firmId',
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRuleId',
    key: 'procurationFeeRule',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEE_RULES,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFeeId',
    key: 'procurationFeeId',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      sorter: true,
      listName: FieldType.PROCURATION_FEES,
    },
  },
];